const findCorrectClickTarget = function(element, cls) {
  let el = element;

  while (!el.classList.contains(cls)) {
    el = el.parentElement;
  }

  return el;
};

const showPanel = function(
  trigger,
  primaryTarget,
  primaryClass,
  secondTarget,
  secondClass,
) {
  trigger.classList.add('is-active');
  primaryTarget.classList.add(primaryClass);

  trigger.setAttribute('aria-expanded', true);
  primaryTarget.setAttribute('aria-hidden', false);

  if (secondTarget != null && secondClass != null) {
    secondTarget.classList.add(secondClass);
  }
};

const hidePanel = function(
  trigger,
  primaryTarget,
  primaryClass,
  secondTarget,
  secondClass,
) {
  trigger.classList.remove('is-active');
  primaryTarget.classList.remove(primaryClass);

  trigger.setAttribute('aria-expanded', false);
  primaryTarget.setAttribute('aria-hidden', true);

  if (secondTarget != null && secondClass != null) {
    secondTarget.classList.remove(secondClass);
  }
};

const clickEvent = function(event) {
  event.preventDefault();
  event.stopPropagation();

  const trigger = findCorrectClickTarget(event.target, 'js-toggle-element');
  const primaryTarget = document.querySelector(trigger.dataset.primaryTarget);
  const primaryClass = trigger.dataset.primaryClass || 'is-visible';
  let secondTarget = document.querySelector(trigger.dataset.secondTarget);
  let { secondClass } = trigger.dataset;

  if (secondTarget == null || secondClass == null) {
    secondTarget = null;
    secondClass = null;
  }

  if (trigger.classList.contains('is-active')) {
    hidePanel(trigger, primaryTarget, primaryClass, secondTarget, secondClass);
  } else {
    showPanel(trigger, primaryTarget, primaryClass, secondTarget, secondClass);
  }
};

const toggleElement = function() {
  const triggers = document.querySelectorAll('.js-toggle-element');

  for (let i = triggers.length - 1; i >= 0; i -= 1) {
    triggers[i].addEventListener('click', clickEvent, false);
  }
};

export default toggleElement;



// WEBPACK FOOTER //
// ./src/scripts/modules/toggle-element.js